/**
 * Page view tracking: single "page_viewed" event with path and derived page_slug.
 * Easy to maintain - path rules in one small function.
 */

/**
 * Derive a stable page_slug from pathname for grouping in Mixpanel.
 * Add or adjust path prefixes here to keep slugs consistent.
 */
function getPageSlugFromPath(pathname) {
  const path = pathname.replace(/\/$/, "") || "/";
  if (path === "/") return "signup";
  if (path === "/login") return "login";
  if (path === "/confirm-email") return "confirm_email";
  if (path.startsWith("/forgot-password")) return "forgot_password";
  if (path.startsWith("/reset-password")) return "reset_password";
  if (path === "/auto-login") return "auto_login";
  if (path === "/home") return "home";
  if (path === "/dashboard") return "dashboard";
  if (path.startsWith("/quick-start")) return "quick_start";
  if (path === "/create-organisation") return "create_organisation";
  if (/^\/organisation\/[^/]+\/project$/.test(path)) return "organisation_project";
  if (path.startsWith("/members")) return "members";
  if (path.startsWith("/test-scenario-builds")) return "test_scenario_builds";
  if (path.startsWith("/test-scenarios")) return "test_scenarios";
  if (path.startsWith("/environments")) return "environments";
  if (path.startsWith("/test-suite-builds")) return "test_suite_builds";
  if (path.startsWith("/test-suites")) return "test_suites";
  if (path.startsWith("/test-plan-builds")) return "test_plan_builds";
  if (path.startsWith("/test-plans")) return "test_plans";
  if (path.startsWith("/build-reports")) return "build_reports";
  if (path.startsWith("/js-functions")) return "js_functions";
  if (path.startsWith("/data-sets")) return "data_sets";
  if (path.startsWith("/settings")) return "settings";
  if (path.startsWith("/public-page")) return "public_page";
  if (path.startsWith("/search")) return "search";
  if (path.startsWith("/faqs")) return "faqs";
  if (path.startsWith("/collection-forks")) return "collection_forks";
  if (path.startsWith("/memory")) return "memory";
  if (path.startsWith("/transactions")) return "transactions";
  if (path.startsWith("/auth/")) return "auth_callback";
  if (path.startsWith("/ai-agent")) return "ai_agent";
  if (path.startsWith("/api-overview")) return "api_overview";
  if (path.startsWith("/collections")) return "collections";
  return "unknown";
}

/**
 * Returns payload for a page view: one event name + props with path and page_slug.
 * Use with MixpanelService.track(payload.event_name, payload.properties).
 */
export function getPageViewEvent(pathname, params = {}) {
  const path = pathname || "/";
  const page_slug = getPageSlugFromPath(path);
  const properties = {
    path,
    page_slug,
    ...(params.collectionSlug && { collection_slug: params.collectionSlug }),
    ...(params.folderSlug && { folder_slug: params.folderSlug }),
    ...(params.entitySlug && { entity_slug: params.entitySlug }),
  };
  if (path.startsWith("/auth/supabase")) properties.provider = "supabase";
  if (path.startsWith("/auth/github")) properties.provider = "github";
  return {
    event_name: page_slug+"_page_viewed_app",
    properties,
  };
}
